import React, {lazy} from "react";
import {Navigate} from "react-router-dom";

const CntrCompleteReport = lazy(() => import("../pages/rp/cntr/CntrCompleteReport"));
const SmcnCertListBase = lazy(() => import("app/pages/rp/smcnCert/smcnList/SmcnCertListBase"));
const SmcnCertFormBase = lazy(() => import("app/pages/rp/smcnCert/smcnForm/SmcnCertFormBase"));
const SmcnCertDetailBase = lazy(() => import("app/pages/rp/smcnCert/smcnDetail/SmcnCertDetailBase"));
const Portfolio = lazy(() => import("../pages/rp/pfl/Portfolio"))
const Roadmap = lazy(() => import("../pages/rp/rdmp/Rdmp"))
const Matching = lazy(() => import("../pages/rp/MatchingTarget"))
const MatchingSearchList = lazy(() => import("../pages/rp/matchingTarget/MatchingSearchList"))
const MatchingSearchDetail = lazy(() => import("../pages/rp/matchingTarget/MatchingSearchDetail"))
const CntrList = lazy(() => import("../pages/rp/cntr/CntrList"))
const TrdNegoDetail = lazy(() => import("../pages/rp/cntr/TrdNegoDetail"))
const CntrWriteForm = lazy(() => import("../pages/rp/cntr/CntrWriteForm"))
const InstitutionReg = lazy(() => import("../pages/rp/cntr/InstitutionReg"))
const CntrComplete = lazy(() => import("../pages/rp/cntr/CntrComplete"))
const CntrReport = lazy(() => import("../pages/rp/cntr/CntrReport"));
const UseConfirmationList = lazy(() => import("../pages/rp/useConfirmation/UseConfirmationList"))
const UseConfirmationInsert = lazy(() => import("../pages/rp/useConfirmation/UseConfirmationInsert"))
const UseConfirmationDetail = lazy(() => import("../pages/rp/useConfirmation/UseConfirmationDetail"))
const RlibrList = lazy(() => import("../pages/rp/rlibr/RlibrList"))
const RlibrDetail = lazy(() => import("../pages/rp/rlibr/RlibrDetailPage"))
const RlibrInsert = lazy(() => import("../pages/rp/rlibr/RlibrInsert"))
const ImplWayAnalysis = lazy(() => import("../pages/rp/implWayAnalysis/ImplWayAnalysis"))
const EntreInfoPowerList = lazy(() => import("../pages/rp/entrepreneurInfo/PwStationList"))
const EntrInfoPowerInsert = lazy(() => import("../pages/rp/entrepreneurInfo/PwStationInsert"))
const EntrInfoPowerDetail = lazy(() => import("../pages/rp/entrepreneurInfo/PwStationDetail"))
const ElecUserInsert = lazy(() => import("../pages/rp/entrepreneurInfo/ElectricUserInsert"))
const ElecUserDetail = lazy(() => import("../pages/rp/entrepreneurInfo/ElectricUserDetail"))
const ElecUserList = lazy(() => import("../pages/rp/entrepreneurInfo/ElectricUserList"))
const RdmpGoalSetting = lazy(() => import("../pages/rp/rdmp/RdmpGoalSetting"))
const Rdmp = lazy(() => import("../pages/rp/rdmp/Rdmp"))
const ScenarioDetail = lazy(() => import("../pages/rp/scnro/ScenarioDetail"))

export const rpRouter: any = [
  {path: "rp", element: <Navigate to="impleWayAnalysis" replace/>},
  {path: "/rp/portfolio/:menuActiveTab?", element: <Portfolio/>,},
  {path: "/rp/roadmap", element: <Roadmap/>,},
  {path: "/rp/matchingTarget", element: <Matching/>,},
  {path: "/rp/matchingSearchList", element: <MatchingSearchList/>,},
  {path: "/rp/matchingSearchDetail/:pwplId", element: <MatchingSearchDetail/>,},
  {path: "/rp/cntrlist", element: <CntrList/>,},
  {path: "/rp/trdnegodetail", element: <TrdNegoDetail/>,},
  {path: "/rp/cntrwriteform", element: <CntrWriteForm/>,},
  {path: "/rp/institutionreg", element: <InstitutionReg/>,},
  {path: "/rp/cntrcomplete", element: <CntrComplete/>,},
  {path: "/rp/cntrreport", element: <CntrReport/>},
  {path: "/rp/cntr/complete/report", element: <CntrCompleteReport/>},

  // RE100 플래너 > 인증관리 > 이행수단 실적 등록
  { path: "/rp/smcnCert", element: <SmcnCertListBase /> },
  { path: "/rp/smcnCert/form", element: <SmcnCertFormBase /> },
  { path: "/rp/smcnCert/detail", element: <SmcnCertDetailBase /> },

  {path: "/rp/useConfirmationList/:ucfmCd?", element: <UseConfirmationList/>},
  {path: "/rp/useConfirmationInsert", element: <UseConfirmationInsert/>},
  {path: "/rp/useConfirmationDetail/:emksFuflMeansCd/:smcnCertId", element: <UseConfirmationDetail/>},
  {path: "/rp/rlibr/:menuActiveTab?", element: <RlibrList/>},
  {path: "/rp/rlibrDetail/:menuActiveTab?/:rlibrId", element: <RlibrDetail/>},
  {path: "/rp/rlibrInsert/:menuActiveTab?", element: <RlibrInsert/>},
  {path: "/rp/impleWayAnalysis/:menuActiveTab?", element: <ImplWayAnalysis/>},
  {path: "/rp/entre", element: <EntreInfoPowerList/>},
  {path: "/rp/pwstationlist", element: <EntreInfoPowerList/>},
  {path: "/rp/pwStationInsert", element: <EntrInfoPowerInsert/>},
  {path: "/rp/pwStationDetail/:pwplId", element: <EntrInfoPowerDetail/>},
  {path: "/rp/electricUserList", element: <ElecUserList/>},
  {path: "/rp/electricUserInsert", element: <ElecUserInsert/>},
  {path: "/rp/electricUserDetail/:elecUserId", element: <ElecUserDetail/>},
  {path: "rp/rdmpGoalSetting", element: <RdmpGoalSetting/>},
  {path: "rp/rdmp", element: <Rdmp/>},
  {path: "rp/ScenarioDetail/:scnroId", element: <ScenarioDetail/>},
];